import { render, staticRenderFns } from "./SampleTypeFormModal.vue?vue&type=template&id=66e2e938&"
import script from "./SampleTypeFormModal.ts?vue&type=script&lang=js&"
export * from "./SampleTypeFormModal.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports